import React from 'react';
import { Box, useTheme } from '@mui/material';

/** Flat page background. Kept as a component so pages can stay unchanged. */
const AmbientBackground: React.FC = () => {
  const theme = useTheme();
  return (
    <Box
      aria-hidden
      sx={{ position: 'fixed', inset: 0, zIndex: -1, pointerEvents: 'none', bgcolor: theme.palette.background.default }}
    />
  );
};

export default AmbientBackground;
